import React from "react"
import { TweenLite, Elastic, EndArrayPlugin } from "gsap/all"
// import "./KarmaPoll.scss"

class KarmaPoll extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
      submitted: false
    }

    this.pos = [
      [ // Sad #2
        [72,82,48,82,43,100,43,100],
        [71,82,94,82,99,100,99,100]
      ],
      [ // Sad #1
        [72,86,52,86,48,98,48,98],
        [71,86,90,86,94,98,94,98]
      ],
      [ // Neutral
        [72,90,48,90,50,90,50,90],
        [71,90,94,90,92,90,92,90]
      ],
      [ // Happy #1
        [72,94,52,94,48,82,48,82],
        [71,94,90,94,94,82,94,82]
      ],
      [ // Happy #2
        [72,98,46,98,42,74,42,74],
        [71,98,95,98,101,74,101,74]
      ]
    ]

    this.c = [
      [72,90,48,90,50,90,50,90],
      [71,90,94,90,92,90,92,90]
    ]

    this.EndArrayPlugin = EndArrayPlugin
  }

  componentDidMount() {
    this.currentKarma = this.props.context.data.karma
    // this.initialTween()
  }

  componentWillUnmount() {
    if (this.tweenLeft) this.tweenLeft.kill()
    if (this.tweenRight) this.tweenRight.kill()
  }

  karmaUp = () => {
    if (this.props.context.data.karma < 4) {
      this.currentKarma++

      this.props.context.set({
        karma: this.currentKarma
      }, this.tween)
    }
  }

  karmaDown = () => {
    if (this.props.context.data.karma > 0) {
      this.currentKarma--

      this.props.context.set({
        karma: this.currentKarma
      }, this.tween)
    }
  }

  toggleOpen = () => {
    this.setState({
      open: !this.state.open
    })
  }

  initialTween = () => {
    let karma = this.props.context.data.karma

    let left = `M${this.pos[karma][0][0]},${this.pos[karma][0][1]} C${this.pos[karma][0][2]},${this.pos[karma][0][3]} ${this.pos[karma][0][4]}, ${this.pos[karma][0][5]} ${this.pos[karma][0][6]},${this.pos[karma][0][7]}`,
        right = `M${this.pos[karma][1][0]},${this.pos[karma][1][1]} C${this.pos[karma][1][2]},${this.pos[karma][1][3]} ${this.pos[karma][1][4]}, ${this.pos[karma][1][5]} ${this.pos[karma][1][6]},${this.pos[karma][1][7]}`

    this.leftMouth.setAttribute('d', left)
    this.rightMouth.setAttribute('d', right)
  }

  tween = () => {
    let karma = this.props.context.data.karma

    this.tweenLeft = TweenLite.to(this.c[0], 1.6, {ease: Elastic.easeOut.config(1, 0.75), endArray: this.pos[karma][0], onUpdate: this.setPaths})
    this.tweenRight = TweenLite.to(this.c[1], 1.6, {ease: Elastic.easeOut.config(1, 0.75), endArray: this.pos[karma][1], onUpdate: this.setPaths})

    this.toggleOpen()
  }

  setPaths = () => {
    let left = `M${this.c[0][0]},${this.c[0][1]} C${this.c[0][2]},${this.c[0][3]} ${this.c[0][4]}, ${this.c[0][5]} ${this.c[0][6]},${this.c[0][7]}`,
        right = `M${this.c[1][0]},${this.c[1][1]} C${this.c[1][2]},${this.c[1][3]} ${this.c[1][4]}, ${this.c[1][5]} ${this.c[1][6]},${this.c[1][7]}`

    this.leftMouth.setAttribute('d', left)
    this.rightMouth.setAttribute('d', right)
  }

  render() {
    let currentKarma = this.props.context.data.karma

    return (
      <div className="karma-poll" data-visible={this.state.open || !this.props.fixed} data-fixed={this.props.fixed} data-submitted={this.state.submitted}>

        <div className="karma-poll__buffer">
          <div className="karma-poll__inner">
            <div className="karma-poll__top">
              <span>
                How does this make you feel about the future internet?
              </span>
            </div>
            <div className="karma-poll__bottom">
              <div className="karma-poll__bottom-segment">
                <div className="karma-poll__action karma-poll__action--positive h5" onClick={this.karmaUp} tabIndex="0">
                  <span>
                    Optimistic
                  </span>
                </div>
              </div>
              <div className="karma-poll__bottom-segment">
                <div className="karma-poll__action karma-poll__action--negative h5" onClick={this.karmaDown} tabIndex="0">
                  <span>
                    Pessimistic
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="karma-btn" data-open={this.state.open}>
          <div className="karma-btn__toggle" onClick={this.toggleOpen} data-karma={currentKarma}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 146 146">
              <g className="face">
                <g data-name="eyes">
                  <circle cx="55" cy="61" r="4" stroke="none" fill="black" />
                  <circle cx="87" cy="61" r="4" stroke="none" fill="black" />
                </g>

                <g className="happy-eyes">
                  <circle cx="55" cy="65.5" r="4" stroke="none" fill="#fb998e" />
                  <circle cx="87" cy="65.5" r="4" stroke="none" fill="#fb998e" />
                </g>

                <g className="angry-brow">
                  <path data-name="brow-cover" fill="none" stroke="#fb998e" d="M48,55.8 62,58.2" strokeWidth="2"/>
                  <path data-name="brow-cover" fill="none" stroke="#fb998e" d="M94,55.8 80,58.2" strokeWidth="2"/>
                  <path data-name="brow" fill="none" stroke="black" d="M48,57.8 62,60.2" strokeWidth="2"/>
                  <path data-name="brow" fill="none" stroke="black" d="M94,57.8 80,60.2" strokeWidth="2"/>
                </g>

                <g className="mouth">
                  <path data-name="mouth" fill="none" stroke="#000" d="M72,90 C48,90 50,90 50,90" strokeLinecap="round" strokeWidth="2" ref={leftMouth => (this.leftMouth = leftMouth)} />
                  <path data-name="mouth" fill="none" stroke="#000" d="M71,90 C94,90 92,90 92,90" strokeLinecap="round" strokeWidth="2" ref={rightMouth => (this.rightMouth = rightMouth)} />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    )
  }
}

export default KarmaPoll